import React, { useState, useEffect } from 'react';
export function AIStorefrontVoice() {
  const [windowWidth, setWindowWidth] = useState(() => typeof window !== 'undefined' ? window.innerWidth : 1440);
  useEffect(() => {
    const onResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  const isMobile = windowWidth <= 767;
  const isDesktop = windowWidth > 1024;
  const cards = [{
    img: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/voice-commerce-asset-t3f80f0meze.png',
    title: 'Voice commerce',
    desc: 'Shoppers talk, the store talks back. Ask about sizes, check stock, add to cart — all by voice. Works in every language they speak.'
  }, {
    img: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/multilingual-asset-bhp8n5qglig.png',
    title: 'Speaks 70+ languages',
    desc: 'Every product, every page, every conversation — auto-translated to the shopper\'s language. No copy duplication. No manual upkeep.'
  }];
  return <section id="aisf-voice" style={{
    backgroundColor: '#FCFAF6',
    paddingTop: 'clamp(60px, 8vw, 120px)',
    paddingBottom: 'clamp(60px, 8vw, 120px)'
  }}>
      <div className="section-content" style={{
      maxWidth: '1360px',
      margin: '0 auto',
      padding: '0 24px'
    }}>

        {/* Headline — desktop: flex row with button right-aligned; non-desktop: stacked */}
        {isDesktop ? <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '44px'
      }}>
            <h2 style={{
          fontSize: 'clamp(52px, 7vw, 92px)',
          lineHeight: 1.05,
          color: '#091717',
          margin: 0,
          fontWeight: 400
        }}>
              <span style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400
          }}>Any </span>
              <span style={{
            fontFamily: 'Instrument Serif, serif',
            fontStyle: 'italic',
            fontWeight: 400,
            letterSpacing: '-0.02em'
          }}>voice</span>
              <span style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400
          }}>. Any </span>
              <span style={{
            fontFamily: 'Instrument Serif, serif',
            fontStyle: 'italic',
            fontWeight: 400,
            letterSpacing: '-0.02em'
          }}>language</span>
              <span style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400
          }}>.</span>
            </h2>
            <a href="/book-a-demo" style={{
          display: 'inline-block',
          backgroundColor: '#091717',
          color: '#FCFAF6',
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400,
          fontSize: '16px',
          borderRadius: '999px',
          padding: '12px 24px',
          textDecoration: 'none',
          transition: 'opacity 0.2s ease',
          flexShrink: 0
        }} onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.opacity = '0.85'} onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.opacity = '1'} data-tracking-id="btn-aisf-voice-demo">
              Book a demo
            </a>
          </div> : <h2 style={{
        fontSize: 'clamp(52px, 7vw, 92px)',
        lineHeight: 1.05,
        color: '#091717',
        margin: '0 0 44px 0',
        fontWeight: 400
      }}>
            <span style={{
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400
        }}>Any </span>
            <span style={{
          fontFamily: 'Instrument Serif, serif',
          fontStyle: 'italic',
          fontWeight: 400,
          letterSpacing: '-0.02em'
        }}>voice</span>
            <span style={{
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400
        }}>. Any </span>
            <span style={{
          fontFamily: 'Instrument Serif, serif',
          fontStyle: 'italic',
          fontWeight: 400,
          letterSpacing: '-0.02em'
        }}>language</span>
            <span style={{
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400
        }}>.</span>
          </h2>}

        {/* 2-column card grid */}
        <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
        gap: isMobile ? '32px' : '20px',
        marginBottom: '40px'
      }}>
          {cards.map(card => <div key={card.title} style={{
          overflow: 'hidden'
        }}>
              <img src={card.img} alt={card.title} style={{
            width: '100%',
            display: 'block',
            objectFit: 'cover'
          }} />
              <div style={{
            paddingTop: isMobile ? '20px' : '24px'
          }}>
                <p style={{
              fontSize: '20px',
              fontWeight: 500,
              letterSpacing: '-0.02em',
              color: '#091717',
              marginBottom: '8px',
              lineHeight: 1.3,
              fontFamily: 'Instrument Sans, sans-serif'
            }}>
                  {card.title}
                </p>
                <p style={{
              fontSize: '16px',
              fontWeight: 400,
              color: '#091717',
              lineHeight: 1.5,
              fontFamily: 'Instrument Sans, sans-serif',
              opacity: 0.7
            }}>
                  {card.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* Get a demo button — non-desktop only */}
        {!isDesktop && <div style={{
        marginTop: '40px',
        textAlign: 'center'
      }}>
          <a href="/book-a-demo" style={{
          display: 'inline-block',
          backgroundColor: '#091717',
          color: '#FCFAF6',
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400,
          fontSize: '16px',
          borderRadius: '999px',
          padding: '12px 24px',
          textDecoration: 'none',
          transition: 'opacity 0.2s ease'
        }} onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.opacity = '0.85'} onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.opacity = '1'} data-tracking-id="btn-aisf-voice-demo">
            Book a demo
          </a>
        </div>}

      </div>
    </section>;
}